import { atom } from "recoil";

export interface userDataType {
  uAmount: string;
  tAmount: string;
  uBonded: string;
  apr: string;
  
}

export const userLiqDataState = atom<userDataType>({
  key: "userLiqDataState",
  default: {
    uAmount: "",
    tAmount: "",
    uBonded: "",
    apr: "",
  },
});








/*
import { atom } from "recoil";
import mainnetPoolsList from "../config/mainnet/pools_info.json";
import testnetPoolsList from "../config/testnet/pools_info.json";

const readuserConfig = ()=>{
  // use it when we have generator for
  // const network = (localStorage.getItem("networkState")!) === null ? "testnet" : (localStorage.getItem("networkState")!);

  // for testnet only
  const network:string = "testnet";

  const poolsList = (network === "mainnet")? mainnetPoolsList: testnetPoolsList;

  let userLiqDataMap: Record<string, any> = {};
  poolsList.pairs.forEach((pair) => {
    userLiqDataMap[pair.pair_name] = {
      uAmount: "",
      tAmount: "",
      uBonded: "",
      apr: "",
    };
  });
  return{
    userLiqDataMap: userLiqDataMap,
  }
}

export interface userDataType {

  userLiqDataMap: Record<string, any>
}

export const userLiqDataState = atom<any>({
  key: "userLiqDataState",
  default: readuserConfig(),
});

*/
